module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-5_SE-c9cb0817b649b65ad25043497a212e01.svg";